export default __webpack_public_path__ + "static/media/report-icon.0d1259d6.svg";